import axios from 'axios';
import { envUrlClinicianManagment } from '../config';
import getHeaders from '../utils/getHeaders';

import { logger } from '../logger';

const log = logger();

/**
 * Fetch the list of professionals for a given provider.
 * @param {string} providerId
 * @returns {Promise<Array>|null} List of professionals or null if error occurs.
 */
const getProfessionalList = async (providerId) => {
  const endpoint = `${envUrlClinicianManagment}/api/provider/professionals/${providerId}`;
  // call with no-cache header as this is meant to preload the cache
  const customHeaders = { 'cache-control': 'no-cache' };

  try {
    const response = await axios.get(
      endpoint,
      getHeaders(customHeaders),
    );
    return response.data;
  } catch (err) {
    log.error('Error getting professional list', err);
    return null;
  }
};

const getProfessionalDetails = async (professionalId) => {
  const endpoint = `${envUrlClinicianManagment}/api/professionals/${professionalId}`;
  // call with no-cache header as this is meant to preload the cache
  const customHeaders = { 'cache-control': 'no-cache' };

  try {
    const response = await axios.get(
      endpoint,
      getHeaders(customHeaders),
    );
    return response.data;
  } catch (err) {
    log.error('Error getting professional details', err);
    return null;
  }
};

const getProfessionalAccessRoles = async (professionalId) => {
  const endpoint = `${envUrlClinicianManagment}/api/access-roles/${professionalId}`;
  // call with no-cache header as this is meant to preload the cache
  const customHeaders = { 'cache-control': 'no-cache' };

  try {
    const response = await axios.get(
      endpoint,
      getHeaders(customHeaders),
    );
    return response.data;
  } catch (err) {
    log.error('Error getting access roles', err);
    return null;
  }
};

export {
  getProfessionalList,
  getProfessionalDetails,
  getProfessionalAccessRoles,
};
